const carouselItems = [
  {
    title: '51cg域名导航完全手册',
    desc: '从域名变更原因到最新入口获取方式，全面剖析51cg网址访问的方方面面。无论您是初次接触还是老用户，这本手册都能帮您彻底解决"找不到官网"的困扰。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20navigation%20and%20directory%20concept%20with%20organized%20pathways%20and%20nodes%2C%20warm%20golden%20amber%20and%20cream%20color%20palette%2C%20minimalist%20geometric%20composition%2C%20soft%20ambient%20lighting%2C%20professional%20editorial%20style%2C%20no%20text%20or%20labels&width=1200&height=600&seq=carousel-01-51cg&orientation=landscape',
    tag: '入门必读',
  },
  {
    title: '平台安全防护实战指南',
    desc: '深度解析仿冒站点的识别技巧与防范策略，帮助您建立安全访问习惯，确保每一次访问都通过正确的51cg官方入口。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20security%20and%20protection%20shield%20concept%20with%20layered%20geometric%20patterns%2C%20warm%20coral%20and%20gold%20highlights%2C%20cream%20background%2C%20minimalist%20clean%20design%2C%20no%20text&width=1200&height=600&seq=carousel-02-51cg&orientation=landscape',
    tag: '安全必看',
  },
  {
    title: '51cg社区生态深度观察',
    desc: '走进51cg社区内部，了解用户互动模式、内容流转机制与社区文化特色，发现平台最有活力的角落。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20community%20ecosystem%20visualization%20with%20interconnected%20organic%20shapes%2C%20warm%20amber%20and%20sage%20green%20accents%2C%20cream%20background%2C%20minimalist%20editorial%20style%2C%20no%20text&width=1200&height=600&seq=carousel-03-51cg&orientation=landscape',
    tag: '深度报道',
  },
  {
    title: '从数据看51cg发展趋势',
    desc: '通过关键指标与用户行为数据，勾勒51cg平台的成长轨迹与未来走向，帮助读者理解平台的核心价值与发展潜力。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20data%20analytics%20and%20growth%20trend%20visualization%20with%20rising%20geometric%20elements%2C%20warm%20golden%20and%20coral%20highlights%2C%20cream%20background%2C%20minimalist%20clean%20design%2C%20no%20text&width=1200&height=600&seq=carousel-04-51cg&orientation=landscape',
    tag: '数据洞察',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">精选深度内容，帮助您更全面地了解51cg平台</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] px-2 py-1 rounded-full bg-accent-500 text-background-50 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 flex-1">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}